import cleanedFilename from '~/util/cleanedFilename';

export default {
  INPUT_CONTAINER: `${cleanedFilename(__filename)}-input-container`,
  INPUT: `${cleanedFilename(__filename)}-input`,
  ADD_BUTTON: `${cleanedFilename(__filename)}-add-button`,
};
